import {useEffect, useState} from "react";
import {evictFailedImages, preloadImages} from "./ImageCache.ts";

/** Gates the first display; later asset changes preload without unmounting the map. */
export function useInitialImages(urls: readonly string[], enabled = true): boolean {
    const key = JSON.stringify([...new Set(urls)].sort());
    const [ready, setReady] = useState(false);
    const [failure, setFailure] = useState<{key: string; error: Error}>();

    useEffect(() => {
        if (!enabled) return;
        let active = true;
        const requestedUrls = JSON.parse(key) as string[];
        // A new provider mount (including a retry) must not reuse rejected cache promises.
        evictFailedImages(requestedUrls);
        void preloadImages(requestedUrls).then(() => {
            if (active) setReady(true);
        }).catch(error => {
            if (active) setFailure({key, error: Object.assign(new Error("Bilder konnten nicht geladen werden."), {cause: error})});
        });
        return () => {active = false;};
    }, [enabled, key]);

    if (!ready && failure?.key === key) throw failure.error;
    return ready;
}
